import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppModule } from 'src/app/app.module';

import { CompetenciesRoutingModule } from './competencies-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ResourcesComponent } from './resources/resources.component';
import { CertificationsComponent } from './certifications/certifications.component';
import { TrainingsComponent } from './trainings/trainings.component';
import { AuditsComponent } from './audits/audits.component';
import { OthersComponent } from './others/others.component';
import { ProjectConnectsComponent } from './project-connects/project-connects.component';
import { CompetenciesComponent } from './competencies.component';
import { ItemsCarousalComponent } from 'src/app/components/items-carousal/items-carousal.component';
import { CategorybarComponent } from 'src/app/components/categorybar/categorybar.component';
import { FormsModule } from '@angular/forms';
import { SubCompetencyComponent } from './sub-competency/sub-competency.component';
import { RouterModule } from '@angular/router';
import { CompetencyComponent } from './competency/competency.component';
import { CompetencyInsightsComponent } from './competency-insights/competency-insights.component';
import { SkillMaturityComponent } from './skill-maturity/skill-maturity.component';
import { SubCompetenciesSidebarComponent } from './sub-competencies-sidebar/sub-competencies-sidebar.component';
import { SubCompetenciesContentComponent } from './sub-competencies-content/sub-competencies-content.component';
import { MatCardModule } from '@angular/material/card';
import { ChartModule } from 'primeng/chart';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';


import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { OrgChartComponent } from './org-chart/org-chart.component';
import { SubCompetencyPageComponent } from './competency/sub-competency-page/sub-competency-page.component';
import { ServicelinesSidebarComponent } from './servicelines-sidebar/servicelines-sidebar.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { GSDStaticComponent } from 'src/app/gsdstatic/gsdstatic.component';
import { ToolsComponentComponent } from '../tools-component/tools-component.component';
import { TrainingsTrackerGridComponent } from '../trainings_tracker/trainings_tracker_header/trainings_tracker_grid/trainings_tracker_grid.component';
import { AddTrainingsComponent } from '../Trainings/add-trainings/add-trainings.component';
import { AddToolsComponent } from '../tools-component/Add-tools/add-tools/add-tools.component';
import { PartnershipCreationComponentComponent } from './competency/partnership-creation-component/partnership-creation-component.component';
import { PartnershipGridComponent } from './partnership-grid/partnership-grid.component';
import { MatTabsModule } from '@angular/material/tabs';
import { TrainingSkillsComponent } from '../trainings_tracker/trainings_tracker_header/training-skills/training-skills.component';
import { SkillIndexComponent } from '../trainings_tracker/trainings_tracker_header/skill-index/skill-index.component';
import { InitiateTrainingComponent } from '../trainings_tracker/trainings_tracker_header/initiate-training/initiate-training.component';
import { TrainingActionsComponent } from '../trainings_tracker/trainings_tracker_header/training-actions/training-actions.component';
import { MentorsDashboardComponent } from './mentors-dashboard/mentors-dashboard.component';
@NgModule({
  declarations: [
    CompetenciesComponent,
    ItemsCarousalComponent,
    CategorybarComponent,
    ResourcesComponent,
    CertificationsComponent,
    TrainingsComponent,
    AuditsComponent,
    OthersComponent,
    ProjectConnectsComponent,
    SubCompetencyComponent,
    CompetencyInsightsComponent,
    SkillMaturityComponent,
    SubCompetencyComponent,
    SubCompetenciesSidebarComponent,
    TrainingsComponent,
    ResourcesComponent,
    CertificationsComponent,
    AuditsComponent,
    ProjectConnectsComponent,
    SubCompetenciesContentComponent,
    GSDStaticComponent,

    CompetencyComponent,

    OrgChartComponent,
    SubCompetencyPageComponent,
    ServicelinesSidebarComponent,
    ToolsComponentComponent,
    TrainingsTrackerGridComponent,
    TrainingSkillsComponent,
    AddTrainingsComponent,
    AddToolsComponent,
    PartnershipCreationComponentComponent,
    PartnershipGridComponent,
    SkillIndexComponent,
    InitiateTrainingComponent,
    TrainingActionsComponent,
    MentorsDashboardComponent,
  ],
  imports: [

    CommonModule,
    CompetenciesRoutingModule,
    SharedModule,
    FormsModule,
    RouterModule,
    MatCardModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    ChartModule,
    MatChipsModule,
    MatIconModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,

    })
  ],
})
export class CompetenciesModule { }
